import { Context, createContext, FC, useCallback, useContext } from 'react';

import { AssumeSessionContextInterface } from '@src/core/auth/assume-session/assume-session-context.interface';
import { useInjectableServices } from '@src/server/service-registry.provider';
import { TokenProviderContext } from '@src/core/auth/components/token-provider.component';
import useAuth from '@src/core/auth/components/auth0-wrapper';

export const AssumeSessionContext: Context<AssumeSessionContextInterface> = createContext(null);

export const AssumeSessionProvider: FC = (props) => {
  const { children } = props;
  const { UserService } = useInjectableServices();

  const { logout: authLogout } = useAuth();
  const { assumedIdentityData } = useContext(TokenProviderContext);

  const logout = useCallback(async () => {
    if (assumedIdentityData?.assumerId) {
      await UserService.endUserIdentityAssumption(assumedIdentityData?.assumerId);
    }

    await authLogout();
  }, [authLogout, UserService, assumedIdentityData]);

  return (
    <AssumeSessionContext.Provider
      value={{
        logout,
        assumedIdentityData,
      }}
    >
      {children}
    </AssumeSessionContext.Provider>
  );
};
